// Internal links are authored as root-relative paths without a locale, e.g.
// "/product/product-uri" — the locale is resolved later by DynamicLink. External links
// are authored as absolute URLs, e.g. "https://google.com". Protocol-relative URLs
// ("//example.com") are treated as external.
export const isInternalLink = (url: string): boolean => {
    const trimmed = url.trim()

    return trimmed.startsWith("/") && !trimmed.startsWith("//")
}
